import React, { useCallback, useEffect } from "react";
// Import Swiper React components

// Import Swiper styles
import "swiper/swiper.min.css";
import "swiper/modules/effect-coverflow/effect-coverflow.min.css";
import "swiper/modules/pagination/pagination.min.css";

// import required modules
import "./styles.css";

import HomeHeaderComponent from "./components/header";
import HomeLayoutComponent from "./components/home-layout";
import { useLocation } from "react-router-dom";
import { Flex, useDisclosure } from "@chakra-ui/react";
import WalletSelectModal from "@/components/modal/wallet-modal";
import { EVENT_OPEN_WALLET_MODAL } from "./event/constants";
import Bus from '@/event'
export default function App() {
   const { isOpen, onOpen, onClose } = useDisclosure();
   const location = useLocation();
   const bBlueBg = location.pathname.endsWith("getstart")
   const eventParameters = useCallback(() => { onOpen() }, [onOpen]);
   useEffect(() => {
      Bus.addListener(EVENT_OPEN_WALLET_MODAL, eventParameters);
      return () => {
         Bus.removeListener(EVENT_OPEN_WALLET_MODAL, eventParameters);
      };
   }, [eventParameters]);
   return (
      <Flex flexDir={"column"} minH={'100vh'} backgroundColor={bBlueBg ? '#F0F7FA' : 'white'} minW={'1280px'}>
         <HomeHeaderComponent />
         <HomeLayoutComponent />
         {isOpen && <WalletSelectModal isOpen={isOpen} onClose={onClose} />}
      </Flex>
   );
}